import React from 'react';
import Organization from './Organization';
import Relationship from './Relationship';
import { Container, Header, Divider } from 'semantic-ui-react';


class AboutUs extends React.Component{
  render(){
    return <Container text textAlign='left'>
        <Header as='h3' textAlign='center'>
          Our Organization
        </Header>
        <Divider />
        < Organization />
        < Relationship />
      </Container>;
  }
}

export default AboutUs;
